// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/reporting.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CheckReportFormulaRequest, CheckReportFormulaResponse, CreateReportFormulaRequest, CreateReportFormulaResponse, CreateReportViewRequest, CreateReportViewResponse, DeleteReportFormulaRequest, DeleteReportFormulaResponse, DeleteReportViewRequest, DeleteReportViewResponse, GetReportingSchemaRequest, GetReportingSchemaResponse, ListReportViewsRequest, ListReportViewsResponse, SetDefaultReportViewRequest, SetDefaultReportViewResponse, UpdateReportFormulaRequest, UpdateReportFormulaResponse, UpdateReportViewRequest, UpdateReportViewResponse } from "./reporting_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * ReportingSchemaService serves the workspace's metric/dimension catalog —
 * the single payload the SPA needs to render any report: metric definitions
 * (including goal-generated ones), dimensions, view presets and the resolved
 * default view. Loaded once per session (long staleTime client-side).
 *
 * @generated from service tracker.v1.ReportingSchemaService
 */
export const ReportingSchemaService = {
  typeName: "tracker.v1.ReportingSchemaService",
  methods: {
    /**
     * @generated from rpc tracker.v1.ReportingSchemaService.GetReportingSchema
     */
    getReportingSchema: {
      name: "GetReportingSchema",
      I: GetReportingSchemaRequest,
      O: GetReportingSchemaResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Workspace formulas («своя формула», board Columns): one more metric of
     * the workspace, seen by every member, served in GetReportingSchema
     * (category "custom") and computed by every stats RPC like any metric.
     *
     * @generated from rpc tracker.v1.ReportingSchemaService.CreateReportFormula
     */
    createReportFormula: {
      name: "CreateReportFormula",
      I: CreateReportFormulaRequest,
      O: CreateReportFormulaResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.ReportingSchemaService.UpdateReportFormula
     */
    updateReportFormula: {
      name: "UpdateReportFormula",
      I: UpdateReportFormulaRequest,
      O: UpdateReportFormulaResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.ReportingSchemaService.DeleteReportFormula
     */
    deleteReportFormula: {
      name: "DeleteReportFormula",
      I: DeleteReportFormulaRequest,
      O: DeleteReportFormulaResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CheckReportFormula parses an expression against the workspace's registry
     * and evaluates it over a row of values the caller already holds — the
     * board ReportFormula's «Проверка на текущем отчёте» over the open report's
     * totals. Nothing is saved; the value is the one the registry would serve.
     *
     * @generated from rpc tracker.v1.ReportingSchemaService.CheckReportFormula
     */
    checkReportFormula: {
      name: "CheckReportFormula",
      I: CheckReportFormulaRequest,
      O: CheckReportFormulaResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service tracker.v1.ReportViewService
 */
export const ReportViewService = {
  typeName: "tracker.v1.ReportViewService",
  methods: {
    /**
     * @generated from rpc tracker.v1.ReportViewService.ListReportViews
     */
    listReportViews: {
      name: "ListReportViews",
      I: ListReportViewsRequest,
      O: ListReportViewsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.ReportViewService.CreateReportView
     */
    createReportView: {
      name: "CreateReportView",
      I: CreateReportViewRequest,
      O: CreateReportViewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.ReportViewService.UpdateReportView
     */
    updateReportView: {
      name: "UpdateReportView",
      I: UpdateReportViewRequest,
      O: UpdateReportViewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.ReportViewService.DeleteReportView
     */
    deleteReportView: {
      name: "DeleteReportView",
      I: DeleteReportViewRequest,
      O: DeleteReportViewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * SetDefaultReportView stamps the caller's per-user default.
     *
     * @generated from rpc tracker.v1.ReportViewService.SetDefaultReportView
     */
    setDefaultReportView: {
      name: "SetDefaultReportView",
      I: SetDefaultReportViewRequest,
      O: SetDefaultReportViewResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

